(function () {
  function updateColorLabel() {
    // 1) 選択中の Color input を探す
    const checked = document.querySelector(
      '.variant-input-wrap[data-handle="color"] input[type="radio"][data-variant-input]:checked'
    );
    if (!checked) return;

    // 2) 表示用の span を探す
    const labelSpan = document.querySelector("[data-variant-color-label]");
    if (!labelSpan) return;

    // 3) 番号付きの value をそのまま表示（例: "4 Navy"）
    labelSpan.textContent = checked.value;
  }

  // 初期ロード
  document.addEventListener("DOMContentLoaded", function () {
    updateColorLabel();
  });

  // 変更時（Color / Size どちらでも拾う）
  document.addEventListener("change", function (e) {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (!t.matches('input[type="radio"][data-variant-input]')) return;

    updateColorLabel();
  });
})();
